import React from "react";
import config from "../../config";
import approveLoan from "../../controllers/repayment/approveLoan";
import { enqueueSnackbar } from "notistack";
import rejectLoan from "../../controllers/repayment/rejectLoan";
import disburseLoan from "../../controllers/repayment/disburseLoan";

export default function LoanMenu({
  order,
  mobile,
  loading,
  setLoading,
  callback,
}) {
  const menu = [
    {
      label: "Approve request",
      action: async () => {
        setLoading(true);
        const res = await approveLoan({ id: order?._id }).finally(() => {
          setLoading(false);
        });
        if (res?.return) {
          enqueueSnackbar("Loan Approved!", { variant: "success" });

          const loanRequest = {
            ...res?.data?.loanRequest,
            agent: order?.agent || res?.data?.loanRequest,
          };
          callback?.(loanRequest);
        } else {
          enqueueSnackbar("Something went wrong. please try again later!", {
            variant: "error",
          });
        }
      },
      visible: [
        config.loanStatus.pending.code,
        config.loanStatus.rejected.code,
      ].includes(order?.status),
    },
    {
      label: "Reject request",
      action: async () => {
        setLoading(true);
        const res = await rejectLoan({ id: order?._id }).finally(() => {
          setLoading(false);
        });
        if (res?.return) {
          enqueueSnackbar("Loan rejection successfull!", {
            variant: "success",
          });

          const loanRequest = {
            ...res?.data?.loanRequest,
            agent: order?.agent || res?.data?.loanRequest,
          };
          callback?.(loanRequest);
        } else {
          enqueueSnackbar("Something went wrong. please try again later!", {
            variant: "error",
          });
        }
      },
      visible: [
        config.loanStatus.pending.code,
        // config.loanStatus.approved.code,
      ].includes(order?.status),
    },
    {
      label: "Disburse",
      action: async () => {
        setLoading(true);
        const res = await disburseLoan({ id: order?._id }).finally(() => {
          setLoading(false);
        });
        if (res?.return) {
          enqueueSnackbar("Loan rejection successfull!", {
            variant: "success",
          });

          const loanRequest = {
            ...res?.data?.loanRequest,
            agent: order?.agent || res?.data?.loanRequest,
          };
          callback?.(loanRequest);
          window.location.reload();
        } else {
          enqueueSnackbar("Something went wrong. please try again later!", {
            variant: "error",
          });
        }
      },
      visible: [
        config.loanStatus.approved.code,
        // config.loanStatus.approved.code,
      ].includes(order?.status),
    },

    // {
    //   label: "Price Details",
    //   action: () => {
    //     setHotelPriceDetailModal && setHotelPriceDetailModal(true);
    //   },
    //   visible: isVisible("Price Details"),
    // },
    // {
    //   label: "Modify Reference",
    //   action: () => {},
    //   visible: isVisible("Modify Reference"),
    // },
  ];

  return (
    <div
      className={`${
        !mobile ? "absolute right-2 top-full" : ""
      } p-2 flex flex-col z-10 bg-white rounded-md shadow-xl min-w-[200px]`}
    >
      {menu
        ?.filter((item) => item?.visible)
        ?.map((item, index) => (
          <div
            key={index}
            className="w-full cursor-pointer text-sm text-black py-1 px-2 transition-all hover:text-primary1"
            onClick={item.action}
          >
            <span>{item.label}</span>
          </div>
        ))}
    </div>
  );
}
